/* Preserve visible keyboard focus; hide interaction outlines after mouse/touch. */
(() => {
  if (window.MareldFocus) return;
  window.MareldFocus = true;
  const root = document.documentElement;
  document.addEventListener('pointerdown', () => {
    root.dataset.mareldInput = 'pointer';
  }, true);
  document.addEventListener('keydown', event => {
    if (!event.metaKey && !event.ctrlKey && !event.altKey) {
      root.dataset.mareldInput = 'keyboard';
    }
  }, true);
})();
